import {
  createContext,
  useContext,
  useState,
  type ReactNode,
} from 'react';

interface ChatContextValue {
  activeSessionId: string | null;
  setActiveSessionId: (id: string | null) => void;
  streamingContent: string;
  setStreamingContent: (content: string) => void;
  thinkingContent: string;
  setThinkingContent: (content: string) => void;
  isStreaming: boolean;
  setIsStreaming: (streaming: boolean) => void;
}

const ChatContext = createContext<ChatContextValue | undefined>(undefined);

interface ChatProviderProps {
  children: ReactNode;
}

export function ChatProvider({ children }: ChatProviderProps) {
  const [activeSessionId, setActiveSessionId] = useState<string | null>(null);
  const [streamingContent, setStreamingContent] = useState('');
  const [thinkingContent, setThinkingContent] = useState('');
  const [isStreaming, setIsStreaming] = useState(false);

  return (
    <ChatContext.Provider
      value={{
        activeSessionId,
        setActiveSessionId,
        streamingContent,
        setStreamingContent,
        thinkingContent,
        setThinkingContent,
        isStreaming,
        setIsStreaming,
      }}
    >
      {children}
    </ChatContext.Provider>
  );
}

export function useChatContext(): ChatContextValue {
  const context = useContext(ChatContext);
  if (context === undefined) {
    throw new Error('useChatContext must be used within a ChatProvider');
  }
  return context;
}
